import {
  Component,
  HostListener,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { PageCategoryCO, PageCategoryType, PageCO, PageContentCO, SchoolCO } from 'src/app/shared/models/ApiModels';
import { SchoolDetailsService } from 'src/app/shared/services/school-details.service';
import { PageDataService } from 'src/app/shared/services/page-data.service';

interface ParsedGovtCodes {
  affiliationNo?: string;
  schoolCode?: string;
  udiseNo?: string;
  trust?: string;
  schoolClass?: string;
}

const MOBILE_BREAKPOINT = 768;

@Component({
  selector: 'app-header2',
  templateUrl: './header2.component.html',
  styleUrls: ['./header2.component.scss']
})
export class Header2Component {
  isMobile = false;
  isMenuOpen = false;

  school: SchoolCO | null = null;
  govtCodes: ParsedGovtCodes = {};

  private destroy$ = new Subject<void>();

  constructor(
    private snackBar: MatSnackBar,
    private schoolService: SchoolDetailsService,
    private pageDataService: PageDataService
  ) {}

  // -------------------- Lifecycle --------------------

ngOnInit(): void {
  this.updateScreenSize();

  // ---------------- SCHOOL ----------------

  this.schoolService.schoolState$
    .pipe(takeUntil(this.destroy$))
    .subscribe(state => {

      if (state.error) {
        this.showError(state.error);
      }

      if (!state.data) {
        this.resetSchoolState();
        return;
      }

      this.school = state.data;
      this.govtCodes = this.parseGovtCode(this.school.govtCode);
    });

  // ---------------- PAGE DATA ----------------

  this.pageDataService.pageData$
    .pipe(
      takeUntil(this.destroy$),
      tap(data => {

        // console.log(data);

        if (!data?.length) return;

        const page = data.find(
          page => page?.name?.toLowerCase() === 'header'
        );

        if (!page) return;

        this.extractHeaderData(page);
      })
    )
    .subscribe();

  // LOAD DATA

  this.pageDataService.loadPageData();
}

  private extractHeaderData(page: PageCO): void {
    if (!page.category?.length) return;

    const categoryMap = new Map<PageCategoryType, PageCategoryCO>();

    page.category.forEach(cat =>
      categoryMap.set(cat.category, cat)
    );

    this.buildFeeRules(categoryMap);
  }

  feeRulesContent?: PageContentCO;
  private buildFeeRules(map: Map<PageCategoryType, PageCategoryCO>): void {
    const feeRules = map.get(PageCategoryType.PAY_FEES);
    this.feeRulesContent = feeRules?.content?.[0];
    console.log(this.feeRulesContent)
  }

  openPayFeesLink(): void {

    const link = this.feeRulesContent?.content;

    if (!link) {
      this.showError('Pay fees link not available');
      return;
    }

    window.location.href = link;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // -------------------- Screen Handling --------------------

  @HostListener('window:resize')
  onResize(): void {
    this.updateScreenSize();
  }

  private updateScreenSize(): void {
    this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // -------------------- Helpers --------------------

  private resetSchoolState(): void {
    this.school = null;
    this.govtCodes = {};
  }

  private parseGovtCode(code?: string): ParsedGovtCodes {
    if (!code) return {};

    const [
      affiliationNo,
      schoolCode,
      udiseNo,
      trust,
      schoolClass
    ] = code.split('||');

    return {
      affiliationNo,
      schoolCode,
      udiseNo,
      trust,
      schoolClass: schoolClass?.toUpperCase()
    };
  }

  getFilePath(fileUUID?: string): string | null {
    return fileUUID
      ? `${ApiUrls.downloadFileUrl}${fileUUID}`
      : null;
  }

  private showError(message: string): void {
    this.snackBar.open(message, 'x', { duration: 3000 });
  }

  showEnquiry = false;
  openEnquiry(): void {
    this.showEnquiry = true;
  }

  closeEnquiry(): void {
    this.showEnquiry = false;
  }
}
